
import { withRouter } from 'helpers/withRouter'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Navigate } from "react-router-dom";

export class ProjectPrintContainer extends Component {

  render() {
    const { error, project, projectFetched, router } = this.props
    const { slug, locale } = router.params
    return <Navigate to={`/${locale}/projects/${slug}`} />
  }
}

ProjectPrintContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.object,
  project: PropTypes.object.isRequired,
  projectFetched: PropTypes.number.isRequired,
  router: PropTypes.shape({
    params: PropTypes.object.isRequired,
  }).isRequired,
}

const mapStateToProps = (state) => {
  const { error, project, projectFetched } = state.project
  return {
    error,
    project,
    projectFetched,
  }
}

export default connect(mapStateToProps)(withRouter(ProjectPrintContainer))
